import { SET_FILTERS_IN_STORE } from "./types"

export const setFiltersInStore = (data) => {
    return {
        type: SET_FILTERS_IN_STORE,
        data
    }
}